import { getFocusedField } from "web_myplann/Shared/Utils/getFocusedField";

export const revealFocusedField = (visibleHeight: number) => {
	const field = getFocusedField();
	if (!field) {
		return;
	}

	const { top, bottom } = field.getBoundingClientRect();
	if (top < 0 || bottom > visibleHeight) {
		field.scrollIntoView({ block: "center", behavior: "smooth" });
	}
};
